import { Button, makeStyles } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { FaEye, FaRegStickyNote } from 'react-icons/fa';
import { FilterToolbar } from '../../components/FilterToolbar';
import { FilterChip } from './FilterChip';

const useStyles = makeStyles((theme) => ({
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
    // width: '80%',
  },
}));

function useActivities(page, limit, filters) {
  const [activities, setActivities] = useState([]);

  const filtersToSend = useMemo(() => {
    const filtersToSend = {};

    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        filtersToSend[key] = filters[key];
      }
    });

    return filtersToSend;
  }, [filters]);

  useEffect(() => {
    fetch(
      `https://api.edicionesmilenio.com/api/evaluations/filter?page=${
        page + 1
      }&limit=${limit}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filtersToSend),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        let a = data?.data?.docs?.map((activity) => ({
          id: activity?._id,
          title: activity?.title,
          evaluationType: activity?.evaluationType,
          description: activity?.description,
          grade: activity?.grade?.name,
          serie: activity?.serie?.name,
          period: activity?.period,
          questions: activity?.questions,
        }));

        setActivities({ ...data?.data, docs: a });
      });
  }, [filtersToSend, limit, page]);

  return {
    activities,
    setActivities,
  };
}

export function WorkShops() {
  const defaultFilters = {
    serie: '',
    grade: '',
    period: '',
    evaluationType: '',
    questions: '',
  };

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sortOrder, setSortOrder] = useState({});
  const [searchValue, setSearchValue] = useState('');
  const [openFilter, setOpenFilter] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);

  const { activities, setActivities } = useActivities(page, limit, filters);

  const sort = useCallback(
    (changedColumn, direction) => {
      const sortFunction = (a, b) => {
        if (a[changedColumn] < b[changedColumn]) {
          return direction === 'asc' ? -1 : 1;
        }
        if (a[changedColumn] > b[changedColumn]) {
          return direction === 'asc' ? 1 : -1;
        }
        return 0;
      };

      const sortedState = [...activities.docs];

      sortedState?.sort(sortFunction);

      JSON.stringify(sortedState) !== JSON.stringify(activities.docs) &&
        setActivities((prevState) => ({ ...prevState, docs: sortedState }));
    },
    [activities.docs, setActivities]
  );

  const search = async () => {
    const response = searchValue
      ? await fetch(
          `https://api.edicionesmilenio.com/api/evaluations-search/${searchValue}?page=${
            page + 1
          }&limit=${limit}`
        )
      : await fetch(
          `https://api.edicionesmilenio.com/api/evaluations?page=${
            page + 1
          }&limit=${limit}`
        );

    const data = await response.json();

    let a = data?.data?.docs?.map((activity) => ({
      id: activity?._id,
      title: activity?.title,
      evaluationType: activity?.evaluationType,
      description: activity?.description,
      grade: activity?.grade?.name,
      serie: activity?.serie?.name,
      period: activity?.period,
      questions: activity?.questions,
    }));

    setActivities({ ...data?.data, docs: a });
  };

  useEffect(() => {
    if (activities && Object.keys(sortOrder).length) {
      sort(Object.keys(sortOrder)[0], Object.values(sortOrder)[0]);
    }
  }, [sortOrder, activities, sort]);

  const classes = useStyles();

  const activityColumns = [
    {
      name: 'title',
      label: 'Título',
      options: {
        filter: false,
      },
    },
    {
      name: 'evaluationType',
      label: 'Tipo de actividad',
    },
    {
      name: 'grade',
      label: 'Grado',
    },
    {
      name: 'serie',
      label: 'Serie',
    },
    {
      name: 'period',
      label: 'Periodo',
    },
    {
      name: 'questions',
      label: 'Preguntas',
    },
    {
      name: 'herramientas',
      label: 'Herramientas',
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <div>
              <button
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open(
                    `/admin/workshops-preview/${activities?.docs[dataIndex]?.id}`,
                    '_blank'
                  );
                }}
              >
                <FaEye />
              </button>
              <button
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  window.open(
                    `/admin/workshops-review/${activities?.docs[dataIndex]?.id}`,
                    '_blank'
                  );
                }}
              >
                <FaRegStickyNote />
              </button>
            </div>
          );
        },
      },
    },
  ];

  function handleDelete(rowsDeleted) {
    rowsDeleted?.data?.forEach((row) => {
      fetch(
        `https://api.edicionesmilenio.com/api/evaluations/${
          activities?.docs[row?.dataIndex]?.id
        }`,
        {
          method: 'DELETE',
        }
      );
    });
  }

  return (
    <div style={{ width: '100%', padding: '20px' }}>
      <p className={classes.formSpan}>
        Estimado administrador, desde esta sección podrás visualizar la lista de
        actividades creadas en la plataforma para cada libro de cada serie,
        desde esta sección podrá gestionar cada una de ellas, ten mucha
        precaución de eliminar alguna de ellas, si ya cuenta contenido asociado,
        este proceso no se puede recuperar.
      </p>
      <MUIDataTable
        title={'Actividades'}
        data={activities?.docs || []}
        columns={activityColumns}
        options={{
          serverSide: true,
          count: activities?.totalDocs || 0,
          page,
          rowsPerPage: limit,
          customToolbar: () => {
            return (
              <FilterToolbar
                openFilter={openFilter}
                setOpenFilter={setOpenFilter}
              >
                <FilterChip
                  setOpenFilter={setOpenFilter}
                  filters={filters}
                  defaultFilters={defaultFilters}
                  setFilters={setFilters}
                />
              </FilterToolbar>
            );
          },
          customSearchRender: (_, handleSearch, hideSearch) => {
            return (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '20px',
                  padding: '20px',
                }}
              >
                <input
                  type="text"
                  value={searchValue || ''}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    handleSearch(e.target.value);
                  }}
                  placeholder={'Buscar'}
                  style={{
                    fontSize: '16px',
                    padding: '5px 5px 5px 5px',
                    border: '1px solid rgba(0,0,0,0.2)',
                    borderRadius: '4px',
                    width: '100%',
                    marginBottom: '20px',
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    search();
                    hideSearch();
                  }}
                  style={{
                    width: 'max-content',
                    marginBottom: '20px',
                    padding: '10px',
                    border: '1px solid rgba(0,0,0,0.2)',
                    borderRadius: '4px',
                    fontSize: '14px',
                  }}
                >
                  Buscar
                </Button>
              </div>
            );
          },
          onColumnSortChange: (changedColumn, direction) =>
            setSortOrder({ [changedColumn]: direction }),
          textLabels: {
            body: {
              noMatch: 'Lo sentimos, no se encontraron registros coincidentes',
              toolTip: 'Ordenar',
              columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
            },
            pagination: {
              next: 'Siguiente',
              previous: 'Anterior',
              rowsPerPage: 'Filas por página:',
              displayRows: 'de',
            },
            toolbar: {
              search: 'Buscar',
              downloadCsv: 'Descargar CSV',
              print: 'Imprimir',
              viewColumns: 'Ver columnas',
              filterTable: 'Filtrar tabla',
            },
            filter: {
              all: 'Todos',
              title: 'FILTROS',
              reset: 'REINICIAR',
            },
            viewColumns: {
              title: 'Mostrar columnas',
              titleAria: 'Mostrar/Ocultar columnas de tabla',
            },
            selectedRows: {
              text: 'fila(s) seleccionadas',
              delete: 'Eliminar',
              deleteAria: 'Eliminar filas seleccionadas',
            },
          },
          filter: false,
          onTableChange: (action, tableState) => {
            switch (action) {
              case 'changePage':
                setPage(tableState.page);
                break;
              case 'changeRowsPerPage':
                setLimit(tableState.rowsPerPage);
                break;
              default:
                break;
            }
          },
          onRowsDelete: (rowsDeleted) => {
            handleDelete(rowsDeleted);
          },
        }}
      />
    </div>
  );
}
